<template>
  <v-dialog
    persistent
    v-model="showWindow"
    scrollable
    max-width="650"
    max-height="90%"
    min-width="90%"
  >
    <v-card height="100%" :loading="!fetched">
      <v-card-actions>
        <h3 class="pa-3 pt-1 pb-1">{{ $t("goods.goods_reserving") }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="showWindow = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="pa-5">
        <h3>{{part_number}} {{brand}}, {{$t('common.amount')}}: {{ amount }}</h3>
        <v-simple-table v-if="fetched && available_goods.length">
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                {{ $t("common.storage") }}
              </th>
              <th class="text-left">
                {{ $t("common.amount") }}
              </th>
              <th class="text-left">

              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item in available_goods"
                :key="item.id"
            >
              <td>
                {{ item.stock_location }}
              </td>
              <td>
                {{ item.amount_calculated }}
              </td>
              <td>
                <v-btn
                    color="success"
                    elevation="0"
                    @click="select(item)"
                >
                {{ $t('common.select') }}
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-alert
            dense
            outlined
            type="error"
            class=""
            v-if="fetched && !available_goods.length"
        >
          {{ $t("goods.goods_of_the_required_nomenclature_are_not_in_stock") }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "GoodsReservationWindow",
  props: {
    show: false,
    part_number: null,
    brand: null,
    amount: null
  },
  data() {
    return {
      foo: 'bar',
    };
  },
  computed: {
    ...mapFields("goods_remains", ["available_goods", "fetched"]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  watch: {
    show(to) {
      if (to) {
        this.$store.dispatch("goods_remains/selectGoodsForReserve", {
          part_number: this.part_number,
          brand: this.brand,
          amount: this.amount
        });
      }
    },
  },
  methods: {
    select(item){
      if(item.amount_calculated < this.amount){
        this.$error(this.$t('goods.not_enough_stock_to_reserve', [item.amount_calculated, this.amount]))
        return;
      }
      this.$emit('selectGoodsForReserve', {
        nomenclature_id: item.nomenclature_id,
        storage_id: item.storage_id,
        storage_rack_id: item.storage_rack_id,
        storage_rack_shelve_id: item.storage_rack_shelve_id
      })
    }
  },
};
</script>

<style scoped></style>
